import { render, staticRenderFns } from "./ModalBaixaPagamento.vue?vue&type=template&id=b24aca0c"
import script from "./ModalBaixaPagamento.vue?vue&type=script&lang=js"
export * from "./ModalBaixaPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports